import React from "react"
import Grid from '@material-ui/core/Grid';

/* importing custom modules */
import StaticExpander from '../components/Material-UI-Components/StaticExpander.js';
import Layout from '../components/layout'
import ContactForm from '../components/Custom Modules/ContactForm';
import SEO from "../components/seo"

/* importing json files */
import Psychotherapy from '../components/Page-Data/Psychotherapy.json';

/* importing images */
import Logo from '../images/CounsellingPsy/logo.png';

const CounselingAndPsychotherapy = () => (
  <Layout>
    <SEO 
      title="Best Psychotheraphy Counselling in India at Pratiiti.com" 
      description="Psychotheraphy Counselling-Pratiiti.com provide you qualified counsellors for Psychotheraphy counselling at affordable rates. in India at Pratiiti.com"
      canonical={"https://www.pratiiti.in/counselling-and-psychotherapy"}
    />
    <div>
      <Grid xs={12} md={6} sm={3}>
        <div className="logo">
          <img src={Logo} alt="Psychotheraphy Counselling logo"/>
        </div>
      </Grid>
        <StaticExpander
            data = {Psychotherapy}
        />
	  </div>
    <ContactForm/>
  </Layout>
)

export default CounselingAndPsychotherapy
